export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    month = "",
    year = "",
    debitCounterpartLabels = [],
    creditCounterpartLabels = [],
    rows = [],
    totals = {},
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let rowsHtml = "";
  rows.forEach((row) => {
    rowsHtml += `
      <tr>
        <td class="border text-center">${row.index || ""}</td>
        <td class="border px-1">${row.customerName || ""}</td>
        <td class="border text-right px-1">${fmt(row.openingDebitBalance)}</td>
        ${(row.debitSideValues || [0, 0, 0, 0, 0]).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
        <td class="border text-right px-1 font-bold bg-light">${fmt(row.debitSideTotal)}</td>
        ${(row.creditSideValues || [0, 0, 0, 0, 0]).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
        <td class="border text-right px-1 font-bold bg-light">${fmt(row.creditSideTotal)}</td>
        <td class="border text-right px-1 font-bold" style="color: ${row.closingDebitBalance < 0 ? "red" : "blue"}">${fmt(row.closingDebitBalance)}</td>
      </tr>
    `;
  });

  const totalsHtml = `
    <tr class="font-bold bg-grey">
      <td class="border text-center" colspan="2">Cộng</td>
      <td class="border text-right px-1">${fmt(totals.openingDebitBalance)}</td>
      ${(totals.debitSideValues || [0, 0, 0, 0, 0]).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
      <td class="border text-right px-1">${fmt(totals.debitSideTotal)}</td>
      ${(totals.creditSideValues || [0, 0, 0, 0, 0]).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
      <td class="border text-right px-1">${fmt(totals.creditSideTotal)}</td>
      <td class="border text-right px-1">${fmt(totals.closingDebitBalance)}</td>
    </tr>
  `;

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.3;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S04b11-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC ngày 27 tháng 10<br/> năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h3 style="margin: 0; text-transform: uppercase;">BẢNG KÊ SỐ 10</h3>
        <h3 style="margin: 0; text-transform: uppercase;">PHẢI THU CỦA KHÁCH HÀNG (TK 131)</h3>
        <div style="margin-top: 5px; font-style: italic;">Tháng ${month} năm ${year}</div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 10px; table-layout: fixed;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="30">Số TT</th>
            <th class="border" rowspan="2" width="120">Tên người mua</th>
            <th class="border" rowspan="2" width="70">Số dư Nợ đầu tháng</th>
            <th class="border" colspan="6">Ghi Nợ TK 131, ghi Có các TK:</th>
            <th class="border" colspan="6">Ghi Có TK 131, ghi Nợ các TK:</th>
            <th class="border" rowspan="2" width="70">Số dư Nợ cuối tháng</th>
          </tr>
          <tr>
            <!-- Debit Side -->
            ${[...Array(5)].map((_, i) => `<th class="border" width="60">${debitCounterpartLabels[i] || ""}</th>`).join("")}
            <th class="border" width="70">Cộng Nợ TK 131</th>
            <!-- Credit Side -->
            ${[...Array(5)].map((_, i) => `<th class="border" width="60">${creditCounterpartLabels[i] || ""}</th>`).join("")}
            <th class="border" width="70">Cộng Có TK 131</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th><th class="border">B</th><th class="border">C</th>
            <th class="border">1</th><th class="border">2</th><th class="border">3</th><th class="border">4</th><th class="border">5</th><th class="border">6</th>
            <th class="border">7</th><th class="border">8</th><th class="border">9</th><th class="border">10</th><th class="border">11</th><th class="border">12</th>
            <th class="border">13</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          ${totalsHtml}
        </tbody>
      </table>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 10px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 2px; }
      .bg-light { background-color: #f9f9f9; }
      .bg-grey { background-color: #eeeeee; }
      @media print {
        @page { size: landscape; margin: 0.5cm; }
        body { margin: 0; }
      }
    </style>
  `;
};
